__turbopack_context__.v({
  "styledItem": "VideoIndicator-module__PC0QnG__styledItem",
});
